(() => {
  if (window.FortyRoundsApparelGallery) {
    window.FortyRoundsApparelGallery.init(document);
    return;
  }

  class ApparelGallery {
    constructor(root) {
      this.root = root;
      this.frames = [...root.querySelectorAll('[data-apparel-frame]')];
      this.views = [...root.querySelectorAll('[data-apparel-view-button]')];
      this.modes = [...root.querySelectorAll('[data-apparel-mirror]')];
      this.note = root.querySelector('[data-apparel-mirror-note]');
      this.status = root.querySelector('[data-apparel-status]');
      this.color = root.querySelector('[data-apparel-color]');
      this.colorLabel = root.querySelector('[data-apparel-color-name-label]');
      this.productLink = this.color ? root.closest('.rr-feature')?.querySelector('[data-apparel-product-link]') : null;
      this.isProduct = Boolean(root.closest('[data-product-root]'));
      this.mirrorEnabled = root.dataset.mirrorEnabled === 'true';
      const parameters = new URL(location.href).searchParams;
      this.mirrored = this.mirrorEnabled && this.isProduct && parameters.get('fr_mirror') === '1';
      this.current = this.frames.find(frame => frame.dataset.apparelMediaId === root.dataset.initialMedia) || this.frames[0];
      if (!this.current) return;
      this.group = this.current.dataset.apparelGroup;
      this.view = this.current.dataset.apparelView;
      if (this.isProduct) { const requested = this.findView(parameters.get('fr_view')); if (requested) { this.current = requested; this.view = requested.dataset.apparelView; } }
      this.views.forEach(button => button.addEventListener('click', () => {
        this.selectView(button.dataset.apparelViewButton);
      }));
      this.modes.forEach(button => button.addEventListener('click', () => {
        this.setMirrored(button.dataset.apparelMirror === 'true');
      }));
      root.addEventListener('fr:apparel-mirror-change', event => this.setMirrored(event.detail?.mirrored === true));
      this.color?.addEventListener('change', () => {
        const frame = this.frames.find(item => item.dataset.apparelColorName === this.color.value);
        if (frame) this.selectFeatured(frame.dataset.apparelMediaId, true);
      });
      const productRoot = root.closest('[data-product-root]');
      if (productRoot) {
        productRoot.addEventListener('fr:variant-media', event => this.selectFeatured(event.detail?.mediaId, true));
        const selected = productRoot.querySelector('[data-variant-select]')?.selectedOptions[0];
        if (selected?.dataset.featuredMedia) this.selectFeatured(selected.dataset.featuredMedia);
      }
      this.render(false);
      root.querySelector('[data-apparel-tools]').hidden = false;
      root.dataset.apparelReady = 'true';
    }

    findView(view) {
      return this.frames.find(frame => frame.dataset.apparelGroup === this.group && frame.dataset.apparelView === view);
    }

    selectView(view) {
      const frame = this.findView(view);
      if (!frame) return;
      this.current = frame;
      this.view = view;
      this.render(true);
    }

    selectFeatured(mediaId, announce = false) {
      const featured = this.frames.find(frame => frame.dataset.apparelMediaId === String(mediaId));
      if (!featured || featured.dataset.apparelGroup === this.group) return;
      this.group = featured.dataset.apparelGroup;
      this.current = this.findView(this.view) || featured;
      this.view = this.current.dataset.apparelView;
      this.render(announce);
    }

    setMirrored(mirrored) {
      this.mirrored = this.mirrorEnabled && mirrored;
      this.render(true);
    }

    render(announce) {
      const isMirror = this.mirrored && this.mirrorEnabled;
      this.frames.forEach(frame => {
        frame.hidden = frame !== this.current;
        const image = frame.querySelector('img');
        if (image) image.classList.toggle('is-mirrored', frame === this.current && isMirror);
      });
      this.views.forEach(button => {
        const available = Boolean(this.findView(button.dataset.apparelViewButton));
        button.hidden = !available;
        button.setAttribute('aria-pressed', String(button.dataset.apparelViewButton === this.view));
      });
      this.modes.forEach(button => {
        button.disabled = false;
        button.setAttribute('aria-pressed', String((button.dataset.apparelMirror === 'true') === isMirror));
      });
      const colorName = this.current.dataset.apparelColorName;
      if (this.colorLabel) this.colorLabel.textContent = colorName;
      if (this.color && colorName) this.color.value = colorName;
      if (this.productLink) {
        const url = new URL(this.productLink.href, location.origin);
        const variantId = this.color.selectedOptions[0]?.dataset.variantId;
        if (variantId) url.searchParams.set('variant', variantId);
        else url.searchParams.delete('variant');
        this.productLink.href = url.toString();
      }
      if (this.note) this.note.textContent = isMirror ? this.note.dataset.mirrorNote : this.note.dataset.asWornNote;
      this.root.dataset.currentView = this.view;
      this.root.dataset.currentMedia = this.current.dataset.apparelMediaId;
      this.root.dataset.mirrored = String(isMirror);
      if (this.isProduct) {
        const url = new URL(location.href);
        if (announce) url.searchParams.set('fr_view', this.view);
        if (isMirror) url.searchParams.set('fr_mirror', '1'); else url.searchParams.delete('fr_mirror');
        if (url.href !== location.href) history.replaceState(history.state, '', url);
      }
      if (announce && this.status) {
        this.status.textContent = [colorName, this.current.dataset.apparelViewLabel, this.note?.textContent].filter(Boolean).join('. ');
      }
      this.root.dispatchEvent(new CustomEvent('fr:apparel-state', { detail: { mirrored: isMirror } }));
    }
  }

  const init = scope => {
    const galleries = [...scope.querySelectorAll('[data-apparel-gallery]')];
    if (scope.matches?.('[data-apparel-gallery]')) galleries.unshift(scope);
    galleries.forEach(root => {
      if (root.dataset.apparelReady !== 'true') new ApparelGallery(root);
    });
  };
  window.FortyRoundsApparelGallery = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

